import { render, staticRenderFns } from "./FormFeedback.vue?vue&type=template&id=f8055f82"
import script from "./FormFeedback.vue?vue&type=script&lang=js"
export * from "./FormFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports